import React from "react";
import { useUltimosIngresos } from "./UltimosIngresos.hook";
import { UltimosIngresosPropertyCard } from "./PropertyCard";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";
import { EmblaCarousel } from "src/Components/EmblaCarousel";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

interface UltimosIngresosProps {
	className?: string;
}

export const UltimosIngresos: React.FC<UltimosIngresosProps> = ({ 
	className = ""
}) => {
	const { loading, data, error, hasProperties } = useUltimosIngresos();
	const screen = useBreakpoint();

	// Don't show anything while loading or if there's an error
	if (loading || error) {
		return null;
	}

	// Only show if we have properties
	if (!hasProperties || !data.length) {
		return null;
	}

	return (
		<div className={`ultimos-ingresos-container ${className}`} style={{ marginTop: '40px' }}>
            <h2 className="ta-center heading heading-2 high">
				Últimos Ingresos
			</h2>
			<EmblaCarousel 
				options={{
					slidesPerView: screen.xxl ? 6 : screen.xl ? 4 : screen.lg ? 3 : screen.md ? 2 : screen.sm ? 2 : 1,
					navigation: true,
					slidesToScroll: 1,
					align:'center',
					breakpoints: {
						'(min-width:576px)': { slidesToScroll: 2 },
						'(min-width:768px)': { slidesToScroll: 2, align: 'start' },
						'(min-width:992px)': { slidesToScroll: 3, align: 'start' },
						'(min-width:1200px)': { slidesToScroll: 4, align: 'start' },
						'(min-width:1600px)': { slidesToScroll: 6, align: 'start' },
					}
				}}
				className="property-similars-cards"
				totalSlides={data.length}
				title="ultimos-ingresos"
			>
				{loading ?
					[...Array(4)].map((property, i) => {
						return (
							<div key={"ultimos_ingresos_skeleton_" + i} className={"similar"}>
								<PropertyCardSkeleton />
							</div>
						);
					}) :
					data.map((property, i) => {
						return (
							<div key={"ultimos_ingresos_" + i} className={"similar"}>
								<UltimosIngresosPropertyCard data={property} preloadImg={i < 3} />
							</div>
						);
					})
				}
			</EmblaCarousel>
		</div>
	);
};
